import { Link } from 'react-router-dom';
import styles from './marqueeSlider.module.css';
import Marquee from 'react-marquee-slider';


export default function MarqueeSlider({ data }) {

  return (
    <section className='bgAliceBlue'>
      <div className={styles.marquee_container}>
        <Marquee velocity={window.innerWidth > 576 ? 8 : 3} scatterRandomly={false}>

          {data.map(brand => (
            <Link to={`/inventory/${brand.slug}`} key={brand.id} className={styles.marqueeSlide}>
              <img src={brand.image} alt={brand.slug} loading='lazy' />
            </Link>
          ))}

          {data.map(brand => (
            <Link to={`/inventory/${brand.slug}`} key={`duplicate-${brand.id}`} className={styles.marqueeSlide}>
              <img src={brand.image} alt={brand.slug} loading='lazy' />
            </Link>
          ))}

        </Marquee>
      </div>
    </section>
  )
}
